var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPainelDeAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 168,
    height: 98,
    viewBox: "0 0 168 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_510",
    "data-name": "Ret\\xE2ngulo 510",
    width: 4.889,
    height: 4.889,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1324",
    "data-name": "Grupo 1324",
    transform: "translate(-0.308 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1331",
    "data-name": "Grupo 1331"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_377",
    "data-name": "Caminho 377",
    d: "M149.838,77.281H55.04a4.815,4.815,0,0,1-4.815-4.815V17.873a4.815,4.815,0,0,1,4.815-4.815h94.8a4.815,4.815,0,0,1,4.815,4.815V72.466a4.815,4.815,0,0,1-4.815,4.815",
    transform: "translate(-1.229 -0.319)",
    fill: "#b2d6fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_378",
    "data-name": "Caminho 378",
    d: "M154.654,24.257H50.226V17.572a4.513,4.513,0,0,1,4.513-4.514h95.48a4.434,4.434,0,0,1,4.435,4.435Z",
    transform: "translate(-1.229 -0.319)",
    fill: "#80befc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1316",
    "data-name": "Grupo 1316",
    transform: "translate(66.417 15.894)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1315",
    "data-name": "Grupo 1315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1314",
    "data-name": "Grupo 1314",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_379",
    "data-name": "Caminho 379",
    d: "M72.971,18.737a2.445,2.445,0,1,1-2.445-2.445,2.445,2.445,0,0,1,2.445,2.445",
    transform: "translate(-68.083 -16.292)",
    fill: "#b2d6fe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1319",
    "data-name": "Grupo 1319",
    transform: "translate(59.469 15.894)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1318",
    "data-name": "Grupo 1318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1317",
    "data-name": "Grupo 1317",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_380",
    "data-name": "Caminho 380",
    d: "M65.849,18.737A2.445,2.445,0,1,1,63.4,16.292a2.445,2.445,0,0,1,2.445,2.445",
    transform: "translate(-60.961 -16.292)",
    fill: "#b2d6fe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1322",
    "data-name": "Grupo 1322",
    transform: "translate(52.521 15.894)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1321",
    "data-name": "Grupo 1321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1320",
    "data-name": "Grupo 1320",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_381",
    "data-name": "Caminho 381",
    d: "M58.727,18.737a2.445,2.445,0,1,1-2.445-2.445,2.445,2.445,0,0,1,2.445,2.445",
    transform: "translate(-53.838 -16.292)",
    fill: "#b2d6fe"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1325",
    "data-name": "Grupo 1325",
    transform: "translate(0 2.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_382",
    "data-name": "Caminho 382",
    d: "M115.742,64.482l8.85-24.294a25.863,25.863,0,0,1,14.871,13.967Z",
    transform: "translate(-2.961 -0.983)",
    fill: "#22638d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_383",
    "data-name": "Caminho 383",
    d: "M108.4,70.464l7.541,24.731a25.853,25.853,0,1,1,1.193-49.066Z",
    transform: "translate(-2.019 -1.112)",
    fill: "#006fb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_384",
    "data-name": "Caminho 384",
    d: "M113.49,70.28l23.77-10.213a25.844,25.844,0,0,1-16.13,34.914Z",
    transform: "translate(-2.897 -1.563)",
    fill: "#f58601"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1330",
    "data-name": "Grupo 1330",
    transform: "translate(0.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_385",
    "data-name": "Caminho 385",
    d: "M170.8,1.87a2.495,2.495,0,1,1-1.8-1.8,2.5,2.5,0,0,1,1.8,1.8",
    transform: "translate(-4.29 0)",
    fill: "#fdad02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_386",
    "data-name": "Caminho 386",
    d: "M164.56,26.85c-2.565-3.838-2.227-8.1-3.059-8.114s-.6,4.308-3.187,7.991c-1.9,2.7-5.266,4.124-7.529,4.927,2.418.851,5.881,2.349,7.714,5.168,2.186,3.361,1.848,7.784,2.761,7.817.889.032,1.011-4.345,3.328-7.776,1.852-2.745,5.217-4.3,7.3-5.22-2.146-.8-5.57-2.162-7.329-4.793",
    transform: "translate(-3.788 -0.639)",
    fill: "#fdad02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_387",
    "data-name": "Caminho 387",
    d: "M148.4,6.778c-1.654-2.476-1.437-5.225-1.972-5.231s-.385,2.777-2.055,5.152a9.914,9.914,0,0,1-4.855,3.177c1.559.549,3.792,1.515,4.974,3.332,1.41,2.168,1.192,5.02,1.781,5.041.573.02.652-2.8,2.145-5.014a10.81,10.81,0,0,1,4.708-3.366c-1.383-.514-3.591-1.394-4.725-3.091",
    transform: "translate(-3.413 -0.053)",
    fill: "#fdad02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1329",
    "data-name": "Grupo 1329",
    transform: "translate(0.307 -1.944)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1326",
    "data-name": "Grupo 1326",
    transform: "translate(3.557 22.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_388",
    "data-name": "Caminho 388",
    d: "M50.012,74.606A26.975,26.975,0,0,1,17.9,79.426c-5.7-3.107-10.521-6.385-10.625-8.635-.257-5.56,13.624-1.523,15.4-1.546,0,0-22.109-26.574-18.595-30.258S19.671,49.846,19.671,49.846,4.909,30,8.616,26.511,27.1,43.236,27.1,43.236s-9.924-15.691-6.537-18.6,15.081,13.7,15.081,13.7-7.221-11.958-3.2-14.867S44.4,38.147,44.4,38.147l6.531,7.515A21.345,21.345,0,0,1,50.012,74.606Z",
    transform: "translate(-3.699 -23.148)",
    fill: "#80befc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_389",
    "data-name": "Caminho 389",
    d: "M39.391,38.8a.44.44,0,0,0,.1-.453.431.431,0,0,0-.55-.271C29.426,41.4,22.433,46.4,17.569,53.346a.441.441,0,0,0,.1.611.428.428,0,0,0,.6-.1c4.758-6.8,11.61-11.687,20.951-14.944a.433.433,0,0,0,.164-.1",
    transform: "translate(-4.229 -23.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_390",
    "data-name": "Caminho 390",
    d: "M41.652,68.7a.451.451,0,0,0,.06-.075.441.441,0,0,0-.133-.6c-9.9-6.373-18.387,1.989-18.472,2.075a.441.441,0,0,0,0,.619.429.429,0,0,0,.613,0c.326-.327,8.085-7.948,17.395-1.956a.429.429,0,0,0,.538-.059",
    transform: "translate(-4.44 -24.312)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1327",
    "data-name": "Grupo 1327",
    transform: "translate(26.384 9.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_391",
    "data-name": "Caminho 391",
    d: "M45.789,22.046A.427.427,0,0,0,45.872,22a.45.45,0,0,0,.1-.623c-7.036-9.769-18.153-5.041-18.265-4.992h0a.448.448,0,0,0-.228.586.439.439,0,0,0,.58.232c.429-.188,10.586-4.486,17.2,4.7a.439.439,0,0,0,.533.147",
    transform: "translate(-27.439 -10.331)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_392",
    "data-name": "Caminho 392",
    d: "M46.283,16.106a.482.482,0,0,0,.075-.043.393.393,0,0,0,.091-.548c-6.194-8.506-16.141-4.274-16.241-4.23A.4.4,0,0,0,30,11.8a.388.388,0,0,0,.515.2c.384-.167,9.47-4.017,15.295,3.981a.39.39,0,0,0,.473.124",
    transform: "translate(-27.536 -10.194)",
    fill: "#2d2d2d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1328",
    "data-name": "Grupo 1328",
    transform: "translate(0 73.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_393",
    "data-name": "Caminho 393",
    d: "M3.155,75.919a.462.462,0,0,0-.1.011.446.446,0,0,0-.335.532C5.316,88.26,17.376,88.418,17.5,88.418h0a.446.446,0,0,0,0-.892c-.467,0-11.476-.165-13.914-11.258a.442.442,0,0,0-.43-.349",
    transform: "translate(-0.104 -75.919)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_394",
    "data-name": "Caminho 394",
    d: "M.4,81.226a.426.426,0,0,0-.086.009.39.39,0,0,0-.3.465C2.329,92,13.12,92.14,13.228,92.14a.39.39,0,1,0,0-.779c-.417,0-10.269-.145-12.449-9.829A.393.393,0,0,0,.4,81.226",
    transform: "translate(0 -76.064)",
    fill: "#2d2d2d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainelDeAdmin);
export default __webpack_public_path__ + "static/media/painel_de_admin.8ef457fa7805524b433573c5cd08aafb.svg";
export { ForwardRef as ReactComponent };